import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Tabs, Badge } from 'antd';
import './index.less';
import MemberList from './components/MemberList';
import AuditList from './components/AuditList';
import RefuseList from './components/RefuseList';
import { membersCountApi } from '@services/MedProject';
import PageHeader from '@components/PageHeader/PageHeader';
import { useProjectContext } from '@/contexts/ProjectContext';
import { WORKSPACE_PARENT_PATH, WORKSPACE_ROUTE_BASE } from '@/layouts/workspaceConfig';

export default function RelatedProjectList() {
    const params = useParams();
    const { id: projectContextId, name: projectName } = useProjectContext();

    const projectId = Number(params?.projectId ?? params?.id) || 0; // 项目 ID

    useEffect(() => {
        document.title = '成员管理-医项目';
    }, []);

    const [membersCount, setMembersCount] = useState(0);

    const getMembersCount = async () => {
        const res = await membersCountApi({ projectId: projectId, status: 0 });
        if (res.status_code === 200) {
            setMembersCount(res.data);
        }
    };

    useEffect(() => {
        if (!!projectId) {
            getMembersCount();
        }
    }, []);

    const tabsRef = [
        {
            label: '成员列表',
            key: '1',
            children: <MemberList status="1" />,
        },
        {
            label: (
                <Badge count={membersCount} offset={[10, 0]}>
                    待审核
                </Badge>
            ),
            key: '2',
            children: <AuditList status="0" getMembersCount={getMembersCount} />,
        },
        {
            label: '已拒绝',
            key: '3',
            children: <RefuseList status="2" />,
        },
    ];

    const onChange = async key => {};

    return (
        <>
            <PageHeader title="成员管理" breadcrumb={[{ label: '医项目', path: WORKSPACE_PARENT_PATH }, { label: projectName, path: `${WORKSPACE_ROUTE_BASE}/${projectContextId}` }, '成员管理']} />

            <div className="page-route-body">
                <Tabs className="members-tabs" defaultActiveKey="1" destroyOnHidden size="large" tabBarGutter={50} onChange={onChange} items={tabsRef} />
            </div>
        </>
    );
}
